import { Page } from '../types/server-data/ClientConfig';

export type EntityLabel = 'ManCo' | 'Group';

export const getEntityLabelForSection = (
  sectionId: string | null | undefined,
): EntityLabel => (sectionId === 'group' ? 'Group' : 'ManCo');

/** Page title for a section — only rewrites MANCO → Group under the group section. */
export const pageTitleForSection = (
  pageTitle: string,
  sectionId: string | null | undefined,
): string => {
  if (sectionId !== 'group' || !pageTitle) return pageTitle;
  return pageTitle.replace(/\bMANCO\b|\bManCo\b|\bManco\b/g, 'Group');
};

export const pageForSection = (
  page: Page,
  sectionId: string | null | undefined,
): Page => {
  if (sectionId !== 'group') return page;
  return {
    ...page,
    pageTitle: pageTitleForSection(page.pageTitle, sectionId),
  };
};
